import addDotsToPrice from "../price-format";
import { NavLink } from "react-router-dom";
import "./RelatedProduct.css";
// component thể hiện sản phẩm liên quan
const RelatedProduct = (props) => {
  return (
    <div>
      <h5 className="text-center text-muted fs-3 mb-4">Sản phẩm liên quan</h5>
      <div className="d-flex flex-wrap justify-content-center gap-5">
        {props.product.map((prod, index) => {
          return (
            <div key={index} className="text-center">
              <NavLink
                className="text-decoration-none"
                to={`/products/${prod._id}`}
              >
                <img src={prod.img1} alt={prod.name} className="imgUrlDetail" />
                <p className="fw-bold mb-0">{prod.name}</p>
                <p className="text-danger">{addDotsToPrice(prod.price)}</p>
              </NavLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default RelatedProduct;
